import firebase from "gatsby-plugin-firebase"

export const firestore =
  typeof firebase.firestore === "function" ? firebase.firestore() : () => {}
export const auth =
  typeof firebase.auth === "function" ? firebase.auth() : () => {}

export const signInWithGoogle = () => {
  if (typeof firebase.auth === "function") {
    const provider = new firebase.auth.GoogleAuthProvider()

    return auth.signInWithPopup(provider)
  } else {
    return () => {}
  }
}
export default firebase
